const install = (Vue) => {
    const Bus = new Vue({
        methods: {
            emit(event, ...args) {
                this.$emit(event, args);
            },
            on(event, callback) {
                this.$on(event, callback);
            },
            off(event, callback) {
                this.$off(event, callback);
            }
        }
    });
    Vue.prototype.$Bus = Bus;
};
export default install;



// WEBPACK FOOTER //
// ./src/common/js/bus.js